/**
 * v5.1 Phase 52 — Recent failure rows with a CloudWatch Logs Insights
 * deep link per row.
 */

function formatWhen(iso) {
  if (!iso) return "—";
  return iso.replace("T", " ").replace("Z", " UTC");
}

export default function PipelineRecentFailures({ failures = [] }) {
  if (!failures.length) {
    return (
      <p className="admin-page__hint">
        No failures in the selected window — happy pipelines.
      </p>
    );
  }
  return (
    <ul className="admin-pipeline-metrics__failures">
      {failures.map((f, idx) => (
        <li
          key={`${f.executionArn}-${f.startedAt}-${idx}`}
          className="admin-pipeline-metrics__failure"
        >
          <div className="admin-pipeline-metrics__failure-head">
            <span className="admin-pipeline-metrics__failure-agent">
              {f.agentId}
            </span>
            <span className="admin-pipeline-metrics__failure-tenant">
              {f.tenantId}
            </span>
            <span className="admin-pipeline-metrics__failure-when">
              {formatWhen(f.startedAt)}
            </span>
            <span className="admin-pipeline-metrics__failure-cat">
              {f.errorCategory || "uncategorized"}
            </span>
          </div>
          {f.snippet ? (
            <pre className="admin-pipeline-metrics__failure-snippet">
              {f.snippet}
            </pre>
          ) : null}
          {f.logsLink ? (
            <a
              className="admin-pipeline-metrics__failure-link"
              href={f.logsLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              Open in CloudWatch Logs Insights →
            </a>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
